import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import Layers from '@cover/motorstoppen/motorstoppen';

const StyledLayers = styled(Layers)`
	position: absolute;
	height: 100%;
	top: 0%;
	left: 0%;
`

const MotorStoppen = ({ play }) => {
	const layers = createRef();

	useEffect(() => {
		const car = layers.current.querySelector('#motorstoppen_svg__car')
		const cloudCar = layers.current.querySelector('#motorstoppen_svg__cloud-car')
		const cloudTop = layers.current.querySelector('#motorstoppen_svg__cloud-top')
		const cloudTopLeft = layers.current.querySelector('#motorstoppen_svg__cloud-top-left-corner')
		const cloudCenter = layers.current.querySelector('#motorstoppen_svg__cloud-middle-left')
		const cloudBottomLeft = layers.current.querySelector('#motorstoppen_svg__cloud-bottom-left')
		const cloudBottomCenter = layers.current.querySelector('#motorstoppen_svg__cloud-bottom-middle')
		const cloudBottomRight = layers.current.querySelector('#motorstoppen_svg__cloud-bottom-right')
		const meditate = layers.current.querySelector('#motorstoppen_svg__mediating-woman')

		anime({
			targets: meditate,
			autoplay: play,
			loop: true,
			easing: 'easeInOutSine',
			direction: 'alternate',
			delay: 2900,
			endDelay: 1800,
			keyframes: [
				{translateY: '-18%', duration: 3000},
				{translateY: '-17%', translateX: '0.1%', duration: 900},
				{translateY: '-17.7%', translateX: '-0.1%', duration: 900},
				{translateY: '-17%', translateX: '0.05%', duration: 900},
				{translateY: '-17.8%', translateX: '0.15%', duration: 900},
				{translateY: 0, duration: 2700},
			]
		});

		anime({
			targets: car,
			autoplay: play,
			delay: 1000,
			endDelay: 3000,
			loop: true,
			keyframes: [
				{translateX: '-100%', easing: 'easeInSine', duration: 1000},
				{opacity: 0, duration: 0},
				{translateX: '200%', duration: 0},
				{opacity: 1, duration: 0, endDelay: 8000},
				{translateX: '0%', easing: 'easeOutSine', duration: 1000}
			]
		});

		anime({
			targets: cloudCar,
			autoplay: play,
			duration: 2000,
			endDelay: 3500,
			direction: 'alternate',
			delay: 1500,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '-10%',
			translateX: '40%'
		});

		anime({
			targets: cloudTop,
			autoplay: play,
			duration: 2000,
			endDelay: 3400,
			direction: 'alternate',
			delay: 1600,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '-22%',
			translateX: '-7%'
		});

		anime({
			targets: cloudTopLeft,
			autoplay: play,
			duration: 2000,
			endDelay: 2700,
			direction: 'alternate',
			delay: 2300,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '-10%',
			translateX: '-10%'
		});

		anime({
			targets: cloudCenter,
			autoplay: play,
			duration: 2000,
			endDelay: 2200,
			direction: 'alternate',
			delay: 2800,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '-5%',
			translateX: '-25%'
		});

		anime({
			targets: cloudBottomLeft,
			autoplay: play,
			duration: 2000,
			endDelay: 2800,
			direction: 'alternate',
			delay: 2200,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '50%',
			translateX: '-15%'
		});

		anime({
			targets: cloudBottomCenter,
			autoplay: play,
			duration: 2000,
			endDelay: 2900,
			direction: 'alternate',
			delay: 2100,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '30%',
			translateX: '15%'
		});

		anime({
			targets: cloudBottomRight,
			autoplay: play,
			duration: 2000,
			endDelay: 2700,
			direction: 'alternate',
			delay: 2300,
			loop: true,
			easing: 'easeInOutCubic',
			translateY: '10%',
			translateX: '30%'
		});
	}, [play])
	return (
		<>
			<StyledLayers ref={layers}/>
		</>
	)
};

export default MotorStoppen;